import React, { Fragment, useState, useEffect, useContext } from 'react';
import propTypes from 'prop-types';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import DivLayout from 'components/sales/divLayout/divLayout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import DocumentView from 'components/sales/downloadDocView/documentView';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ComplaintReplySupport from 'components/sales/ListFilters/ComplaintReplySupport';
import { toast } from 'react-toastify';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import DistanceCalculator from 'pages/DistanceCalculator/Calculator';
import useLatLng from 'hooks/uselatlng/uselatlng';
import axios from 'axios';
import Config from 'services/config/config';
const headers = ['Ticket ID', 'Assigned To', 'Created On', 'Status', 'Actions'];
const MODULE_TYPE = 'cte_ticket';

const cell = (val) => (val != null && val !== '' ? String(val) : '—');

const findActiveCheckinForTicket = (data, complainId) => {
  if (!data) return null;
  const rows = Array.isArray(data) ? data : [data];
  return (
    rows.find((d) => {
      if (d?.checkout_lat) return false;
      const ticketRef = d.ticket_id ?? d.task_id;
      return ticketRef != null && String(ticketRef) === String(complainId);
    }) || null
  );
};

const checkinLogsForTicket = (data, complainId) => {
  if (!data) return [];
  const rows = Array.isArray(data) ? data : [data];
  return rows.filter((d) => {
    const ticketRef = d.ticket_id ?? d.task_id;
    return ticketRef != null && String(ticketRef) === String(complainId);
  });
};

const isTicketClosed = (ticket) =>
  String(ticket?.internal_status || '').toLowerCase() === 'closed';
const ViewComplainSupportTeam = ({
  complainRaisedTicket,
  closeComplain,
  reopenComplain,
  viewDetails,
  viewComplainDetails,
  saveComplaintReplySupport,
  match,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  history,
  saveAssigneeDetails,
  subIssueDropdown,
  getSubIssueDropdown = [],
  calculateDistance,
  getDistanceData,
  getSiteData,
  distanceData,
  siteData,
}) => {
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [complainId, setComplainId] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSuccessFor, setIsSuccessFor] = useState('');
  const [ticketData, setTicketData] = useState('');
  const [status, setStatus] = useState('');
  const [internalStatus, setInternalStatus] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isReply, setIsReply] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const islatlng = useLatLng();
  const [activeCheckin, setActiveCheckin] = useState(null);
  const [checkinLogs, setCheckinLogs] = useState([]);
  const [isCheckoutInProgress, setIsCheckoutInProgress] = useState(false);
  const [showCheckinPopup, setShowCheckinPopup] = useState(false);
  const [siteId, setSiteId] = useState('');
  const isL2Role = parseInt(localStorage.getItem('fusion-role'), 10) === 53;

  const compId = { complain_id: complainId };
  const handleIsConfirmation = () => {
    setIsConfirmation(!isConfirmation);
  };
  const handleIsSuccess = () => {
    setIsSuccess(!isSuccess);
  };
  const filterToggle = () => {
    setShowFilter(!showFilter);
};
const handleIsReply = () => {
  setIsReply(!isReply);
  history.push(`${baseUrl}/complains-list-l2`);
};
  const handleRaiseTicket = async () => {
    setIsLoading(true);
    await complainRaisedTicket(compId);
    await viewDetails(match.params.id);
    setIsLoading(false);
    setIsSuccessFor(localization.raiseTicket);
    handleIsSuccess();
  };
  const handleCloseComplain = async () => {
    await closeComplain(compId);
    setIsLoading(true);
    await viewDetails(match.params.id);
    setIsLoading(false);
    setIsSuccessFor(localization.closeComplain);
    handleIsConfirmation();
    handleIsSuccess();
  };
  const handleReopen = (val) => {
    if(val){
      (async () => {
        await reopenComplain(compId);
        setIsLoading(true);
        await viewDetails(match.params.id);
        setIsLoading(false);
        setIsSuccessFor(localization.closeComplain);
        handleIsSuccess();
      })();
    }
    
  }

  const toRad = (v) => (v * Math.PI) / 180;
  const calcCrow = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };

  const refreshCheckinData = async () => {
    const resolvedSiteId = siteId || ticketData?.site_id || viewComplainDetails?.site_id;
    if (getDistanceData && resolvedSiteId) {
      await getDistanceData(resolvedSiteId, MODULE_TYPE, match.params.id);
    }
  };

  const handleCheckin = () => {
    setShowCheckinPopup(true);
    toast.info('Opening check-in popup...');
  };

  const handleCheckout = async () => {
    if (isCheckoutInProgress || !activeCheckin) return;
    const checkout_lat = Number(islatlng?.lat);
    const checkout_long = Number(islatlng?.lng);
    if (isNaN(checkout_lat) || isNaN(checkout_long)) {
      toast.error(localization.locationPermission);
      return;
    }
    let checkoutDistance = 0;
    if (siteData?.lead?.latitude && siteData?.lead?.longitude) {
      checkoutDistance = calcCrow(
        checkout_lat,
        checkout_long,
        Number(siteData.lead.latitude),
        Number(siteData.lead.longitude)
      );
    }
    setIsCheckoutInProgress(true);
    try {
      const payload = {
        id: activeCheckin.id,
        checkout_lat,
        checkout_long,
        checkout_distance_in_km: checkoutDistance.toFixed(3),
        checkout_remark: '',
      };
      const res = await axios.post(Config.maintenance.rmCheckOut, payload);
      const isSuccess =
        res?.data?.status === 0 ||
        res?.data?.response?.status === true ||
        res?.data?.response?.data === true;
      if (isSuccess) {
        toast.success('Checked out successfully');
        window.location.reload();
        return;
      }
      toast.error(res?.data?.message || 'Check-out failed. Please try again.');
    } catch (err) {
      toast.error('Check-out failed. Please try again.');
    } finally {
      setIsCheckoutInProgress(false);
    }
  };

  const headerBtns = () => {
    const isClosed = isTicketClosed(ticketData);
    return (
      <Fragment>
        <Button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter" >
          Assigned To
        </Button>
        {!isL2Role && !isClosed && (
          <Button
            onClick={activeCheckin ? handleCheckout : handleCheckin}
            disabled={isCheckoutInProgress}
            className={`ml-2 btn ${activeCheckin ? 'btn-warning' : 'btn-success'}`}
          >
            {activeCheckin
              ? (isCheckoutInProgress ? 'Checking out...' : 'Check Out')
              : 'Check In'}
          </Button>
        )}
        {(isL2Role || activeCheckin) && !isClosed && (
          <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
          >
              <img src={Images?.SelectMenu} alt=""/>
              <b className="site_filters" style={{width: "max-content"}}>
                  {`Reply`}
              </b>
          </Button>
        )}
      </Fragment>
    );
  };
  useEffect(() => {
    setComplainId(match.params.id);
    setTicketData('');
    setStatus('');
    setInternalStatus(null);
    setSiteId('');
    setActiveCheckin(null);
    setCheckinLogs([]);
  }, [match.params.id]);
  useEffect(() => {
    if (
      viewComplainDetails !== null &&
      String(viewComplainDetails?.id) === String(match.params.id)
    ) {
      setTicketData(viewComplainDetails);
      setStatus(viewComplainDetails?.status);
      setInternalStatus(viewComplainDetails?.internal_status);
      const sid = viewComplainDetails?.site_id;
      setSiteId(sid);
      if (!isL2Role && sid && getSiteData) {
        getSiteData(sid);
      }
      if (!isL2Role && sid && getDistanceData) {
        getDistanceData(sid, MODULE_TYPE, match.params.id);
      }
      const tableData = ['id', 'assigned_to', 'created_at', 'status'];
      if (viewComplainDetails && viewComplainDetails.rm_ticket) {
        const data = viewComplainDetails?.rm_ticket?.map((element) =>
          Object.assign(
            {},
            ...tableData.map((key) => ({ [key]: element[key] })),
            {
              Actions: {
                name: 'View Details',
                link: `/dashboard/rm-view/${element.id}`,
              },
            }
          )
        );
        setListData(data);
      }
    }
  }, [viewComplainDetails, getDistanceData, getSiteData, match.params.id]);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await viewDetails(match.params.id);
      setIsLoading(false);
    })();
  }, [viewDetails, match.params.id]);

  useEffect(() => {
    const logs = checkinLogsForTicket(distanceData, match.params.id);
    setCheckinLogs(logs);
    setActiveCheckin(findActiveCheckinForTicket(logs, match.params.id));
  }, [distanceData, match.params.id]);
  const successIconBox = (text) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          {isSuccessFor === localization.raiseTicket
            ? localization.ticketSuccessfullyCreated
            : localization.complainClosedSuccessfully}
        </h5>
        <Button onClick={handleIsSuccess} className="btn btn-primary">
          {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const applyFilter = async (filterData) => {
    if (!isL2Role && !activeCheckin) {
      toast.error('Please check in first to send a reply.');
      return false;
    }
    if(filterData.message == '' || filterData.message == null) {
       toast.error('Please enter message.');
       return false;
    }
    if(filterData.isClosed === true && filterData.issue_related_to == '') {
      toast.error('Issue is required.');
      return false; 
    }

    if(filterData.isClosed === true && filterData.rca == '') {
      toast.error('RCA is required.');
      return false; 
    }
    setIsLoading(true);
    setFilterData(filterData);
    const res = await saveComplaintReplySupport(filterData,match.params.id);
    setIsLoading(false);
    if(res) {
      setIsReply(true);
    }
    filterToggle();
  };

  const assignInputs = {
    assigned_to:'',
    assignee_remark:'',
    complaint_id: '',
    message_from: '',
    send_to: '',
  };
  
  const [selectedAssignTo, setSelectedAssignTo] = useState(assignInputs);
  
  const handleAssignToSubmit = async () => {
    // Assign values to selectedAssignTo object properties
    selectedAssignTo.complaint_id = ticketData.id;
    selectedAssignTo.message_from = ticketData.internal_status === "L2 Pending" ? "L2" : ticketData.internal_status === "CT Pending" ? "CT" : undefined;
    selectedAssignTo.send_to = ticketData.internal_status === "L2 Pending" ? "CT" : ticketData.internal_status === "CT Pending" ? "L2" : undefined;
  
    // Check if assignee is selected
    if(selectedAssignTo.assigned_to === '' || selectedAssignTo.assigned_to === null) {
      toast.error('Please select assignee.');
      return false;
    }
  
    setIsLoading(true);
    setFilterData(filterData); // I'm not sure what you're doing with setFilterData here.
    const res = await saveAssigneeDetails(selectedAssignTo);
    setIsLoading(false);
  
    if(res) {
      setIsReply(true);
    }
  };
  
    


  return (
    <Fragment>
      {!isL2Role && showCheckinPopup && (
        <div className="popup-box" style={{ zIndex: 99999 }}>
          <div className="box">
            <button
              className="btn btn-primary mb-4"
              style={{ cursor: 'pointer', float: 'right', border: '0px', boxShadow: 'none', position: 'relative', top: '-17px' }}
              onClick={() => {
                setShowCheckinPopup(false);
                refreshCheckinData();
              }}
            >
              x
            </button>
            <DistanceCalculator
              siteData={siteData}
              getSiteData={getSiteData}
              calculateDistance={calculateDistance}
              siteId={ticketData?.site_id || siteId}
              moduleType={MODULE_TYPE}
              task_id={parseInt(match.params.id, 10)}
              onSuccess={async () => {
                setShowCheckinPopup(false);
                await refreshCheckinData();
                toast.success('Checked in successfully');
              }}
            />
          </div>
        </div>
      )}
      <Layout
        title={localization.viewComplain}
        Buttons={headerBtns}
        isLoading={isLoading}
        isGoback
        linkFlag
        linkUrl={'/dashboard/complains-list-l2'}
      >
        <PanelCardWithHeading title={localization.complainDetails} status={ticketData?.internal_status}>
          <div className="details-listing">
            <DivLayout heading={localization.complainId} data={ticketData?.id} />
            <DivLayout
              heading={localization.siteNumber}
              data={ticketData?.site_no}
            />
            <DivLayout
              heading={localization.siteName}
              data={ticketData?.site_name}
            />
            <DivLayout
              heading={localization.projectId}
              data={cell(ticketData?.infra_project_id)}
            />
            <DivLayout
              heading={localization.complainRaisedBy}
              data={ticketData?.complain_raised_by}
            />
            <DivLayout
              heading={localization.complainType}
              data={ticketData?.complain_type}
            />
            <DivLayout heading={localization.gate} data={ticketData?.gate} />
            <DivLayout heading={localization.amc} data={ticketData?.amc} />
            <DivLayout
              heading={localization.product}
              data={ticketData?.product}
            />
            <DivLayout
              heading={localization.materialRequired}
              data={ticketData?.material_required}
            />
            <DivLayout
              heading="Is Internet present"
              data={ticketData?.is_internet}
            />
            <DivLayout
              heading="Call to client"
              data={ticketData?.call_client}
            />
            
            <DivLayout
              heading={localization.cDescription}
              data={ticketData?.complain_description}
            />
            {/* <DivLayout
              heading={localization.description}
              data={ticketData.document}
            /> */}
            <DivLayout
              heading={localization.createdOn}
              data={moment(ticketData?.created_at, 'DD-MM-YYYY HH:mm:ss').format(
                'DD-MM-YYYY HH:mma'
              )}
            />
            {/* <DivLayout
              heading={localization.status}
              data={ticketData.status}
              status
            /> */}
            {ticketData?.document && (ticketData?.document?.map((document) => (
             <DocumentView attachment={document} />
            )))}
            {ticketData &&
              ticketData?.troubleshoot &&
              Object.keys(ticketData?.troubleshoot).length > 0 && (
                <Fragment>
                  <h5 className="full-width">{localization.troubleshoot}</h5>
                  <div className="form-group">
                    <div className="details-listing faq-listing">
                      {ticketData.troubleshoot &&
                        ticketData.troubleshoot.questions &&
                        ticketData.troubleshoot.questions.length &&
                        ticketData.troubleshoot.questions.map((obj) => {
                          return (
                            <div className="details-list question-input">
                              <label className="data-title">
                                {obj?.question}
                              </label>
                              {obj?.answers?.length &&
                                obj?.answers?.map((ele, ind) => {
                                  return (
                                    <div className="sub-question" key={ind}>
                                      <label className="label">
                                        {ele?.label}
                                      </label>
                                      <label className="label">
                                        {ele?.answer}
                                      </label>
                                    </div>
                                  );
                                })}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Fragment>
              )}
          </div>
          
          {status?.toUpperCase() !== 'CLOSED' && (
            <div className="form-group full-width">
              {/* <Button
                className="btn btn-primary d-none d-md-inline-block"
                onClick={handleRaiseTicket}
              >
                {localization.raiseTicket}{' '}
                <img src={Images?.ArrowRight} alt="" />
              </Button> */}
            </div>
          )}
        </PanelCardWithHeading>

        {!isL2Role && checkinLogs.length > 0 && (
          <PanelCardWithHeading title="Check-in / Check-out Log">
            <table className="panel-table table table-striped table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Mode</th>
                  <th>Distance (km)</th>
                  <th>Actioned By</th>
                  <th>Checked In At</th>
                  <th>Checked Out At</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {checkinLogs.map((log, idx) => (
                  <tr key={log.id || idx}>
                    <td>{idx + 1}</td>
                    <td>{log.eng_at}</td>
                    <td>{log.distance_in_km}</td>
                    <td>{log.actioned_by || log.checked_in_by || '–'}</td>
                    <td>{log.checkin_time || log.created_at}</td>
                    <td>{log.checkout_time || '–'}</td>
                    <td>
                      <span className={`badge ${!log.checkout_lat ? 'badge-success' : 'badge-secondary'}`}>
                        {!log.checkout_lat ? 'Active' : 'Done'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </PanelCardWithHeading>
        )}

            {/* Messages start */}
            
      {ticketData &&
        ticketData?.messageData &&
        ticketData?.messageData?.map((messageDatas) => ( 

            <PanelCardWithHeading title={`Replied By : `+messageDatas?.message_from+` ( ` +messageDatas?.created_at+ ` )`} colorChange={messageDatas?.message_from == 'Client' && '#fff3f3'}>
              <div className="details-listing">
                <DivLayout heading={`Send To`} data={messageDatas?.send_to} />
                {messageDatas?.rm_ticket_id !== null && messageDatas?.rm_ticket_id !='' ? (  
                  <DivLayout
                    heading={`Ticket Id`}
                    data={messageDatas?.rm_ticket_id}
                  />
                ): 
                  <DivLayout
                    heading={`Created By`}
                    data={(messageDatas?.name !== null) ? messageDatas?.name : 'Client'}
                  />
                }
                {messageDatas?.document && (messageDatas?.document?.map((documentss) => (
                  <DocumentView attachment={documentss} />
                )))}
                <DivLayout
                  heading={`Message`}
                  data={messageDatas?.message}
                />
                {messageDatas?.issue_name !== null && messageDatas?.issue_name != '' && (
                  <DivLayout
                    heading={`Issue Type`}
                    data={messageDatas?.issue_name}
                  />
                )}

                {messageDatas?.sub_issue_name !== null && messageDatas?.sub_issue_name != '' && (
                  <DivLayout
                    heading={`Sub-issue Type`}
                    data={messageDatas?.sub_issue_name}
                  />
                )}

                {messageDatas?.rm_ticket ? 
                <table className='panel-table table table-striped table-bordered'>
                  <thead>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Action</th>
                  </thead>
                  <tbody>
                  {messageDatas?.rm_ticket && (messageDatas?.rm_ticket?.map((rmData) => (
                    
                      <tr>
                        <td>{rmData?.assigned_to}</td>
                        <td>{rmData?.status}</td>
                        <td><a class="btn btn-transparent" href={`/dashboard/rm-view/`+rmData?.id}>View Details</a></td>
                        
                      </tr>
                    
                  )))}
                  </tbody>
                  </table>
                : null }
                
              </div>
            
              
          </PanelCardWithHeading>
        ))}

            {/* Messages end */}

        {/* <PanelCardWithHeading title={localization.raisedTicketsDetails}>
          <TableSection
            data={listData}
            headers={headers}
            detailList={listData}
          />
        </PanelCardWithHeading> */}
        <ComplaintReplySupport
                showFilter={showFilter}
                filterToggle={filterToggle}
                viewDropdown={viewComplainDetails}
                subIssueDropdown={subIssueDropdown}
                getSubIssueDropdown={getSubIssueDropdown}
                internalStatus={internalStatus}
                applyFilter={(val) => applyFilter(val)}
                statusId={'1,2,3'}
                documentUploadUrlPublic={documentUploadUrlPublic}
                documentUrlDataPublic={documentUrlDataPublic}
                // listFilterData={siteFilters?.site_types ? siteFilters : null}
                // siteFilters
            />
      </Layout>


    <>
    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"      aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className={`modal-header ${'assign-pop-up'}`}>
              <h5 className="modal-title" id="exampleModalLongTitle">Assigned To</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {internalStatus === "CT Pending" ? (
                <DropDownInput
                  data={[
                    { id: 'L2 Pending', name: 'L2 Pending' }
                  ]}
                  label={localization.assignTo}
                  required
                  errorMsg={localization.requiredName}
                  getIdValue={(val) => {
                    setSelectedAssignTo({
                      ...selectedAssignTo,
                      assigned_to: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              ) : internalStatus === "L2 Pending" ? (
                <DropDownInput
                  data={[
                    { id: 'CT Pending', name: 'CT Pending' }
                  ]}
                  label={localization.assignTo}
                  required
                  errorMsg={localization.requiredName}
                  getIdValue={(val) => {
                    setSelectedAssignTo({
                      ...selectedAssignTo,
                      assigned_to: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              ) : null}

                <TextAreaInput
                  name="message"
                  type="text"
                  rows={2}
                  className={`inline-css scrollbar-styling`}
                  label={'Assignee Remark'}
                  value={selectedAssignTo?.assignee_remark}
                  inputValue={selectedAssignTo?.assignee_remark}
                  handleChange={(e) => setSelectedAssignTo({ ...selectedAssignTo, assignee_remark: e.target.value })}
                />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary d-none d-md-inline-block" data-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary d-none d-md-inline-block" onClick={handleAssignToSubmit}>Assign</button>
            </div>
          </div>
        </div>
      </div>
    </>
  

      <ModalPop
        title={localization.conf}
        show={isConfirmation}
        handleModalHide={handleIsConfirmation}
      >
        <div className="text-center">
          <h4>{localization.closeComplainConfirmation}</h4>
          <div className="form-group btn-group">
            <Button
              onClick={handleIsConfirmation}
              className="btn btn-transparent"
            >
              {localization.cancel}
            </Button>
            <Button onClick={handleCloseComplain} className="btn btn-primary">
              {localization.continue}
            </Button>
          </div>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.success}
        show={isSuccess}
        handleModalHide={handleIsSuccess}
      >
        {successIconBox()}
      </ModalPop>
      <ModalPop
        title={localization.success}
        show={isReply}
        handleModalHide={handleIsReply}
      >
        <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          Success
        </h5>
        <Button
            className="btn btn-primary mb-4"
            onClick={() => handleIsReply()}
          >
            Close
          </Button>
       
      </div>
      </ModalPop>

      <ModalPop
        title={localization.success}
        show={isReply}
        handleModalHide={handleIsReply}
      >
        <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          Success
        </h5>
        <Button
            className="btn btn-primary mb-4"
            onClick={() => handleIsReply()}
          >
            Close
          </Button>
       
      </div>
      </ModalPop>
    </Fragment>
  );
};
ViewComplainSupportTeam.propTypes = {
  fetchComplainList: propTypes.func,
};
export default ViewComplainSupportTeam;